import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  JobseekerModerationAttributeEnum,
  RejectModel,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-moderation-languages',
  templateUrl: './jobseeker-moderation-languages.component.html',
  styleUrls: ['./jobseeker-moderation-languages.component.less'],
  standalone: false,
})
export class JobseekerModerationLanguagesComponent {
  @Input() languages: any;
  @Input() isCreate: boolean;
  @Input() isEdited: boolean;
  @Input() changes: any;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();
  public jobseekerEnum: any;

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }
  reject(event) {
    this.setDictionary.emit({ key: event.key, value: event.value });
  }

  checkAddedAndModifiedLanguages(id: number) {
    return (
      this.changes.jobseekerLanguageChanges?.addedLanguages?.some(
        (val) => val.worldLanguage.worldLanguageId == id
      ) ||
      this.changes.jobseekerLanguageChanges?.changedLanguages?.some(
        (val) => val.worldLanguage.worldLanguageId == id
      )
    );
  }
}
